import { useEffect, useRef } from "react";

import styled from "styled-components/macro";

import { FnrScreensContainer } from "UI/FnrScreens";

import { useFamilyRegistrationContext } from "../FamilyRegistrationContext";

import ChildrenInfoPanel from "./Panels/ChildrenInfoPanel";
import FinishingUpPanel from "./Panels/FinishingUpPanel";
import GivingPanel from "./Panels/GivingPanel/GivingPanel";
import MemberInfoPanel from "./Panels/MemberInfoPanel";
import WelcomePanel from "./Panels/WelcomePanel";

export default function AdminPanelContent() {
  const {
    state: { familyRegistrationSettings, selectedPanel },
  } = useFamilyRegistrationContext();

  const scrollRef = useRef(null);

  useEffect(() => {
    if (!scrollRef.current.scrollTo) return;
    // scroll to top when panel changes
    scrollRef.current.scrollTo(0, 0);
  }, [selectedPanel]);

  if (!familyRegistrationSettings) return null;

  return (
    <Wrapper ref={scrollRef} className="fam-reg-admin-panel-content-wrapper">
      <Inside>
        <FnrScreensContainer>
          <WelcomePanel key="welcome" />
          <MemberInfoPanel key="member" />
          <ChildrenInfoPanel key="children" />
          <GivingPanel key="giving" />
          <FinishingUpPanel key="finishing" />
        </FnrScreensContainer>
      </Inside>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
  flex-grow: 1;
  z-index: 300;
`;
const Inside = styled.div`
  padding: 20px;
  padding-bottom: 120px;
`;
